// components/widgets/Module5/ClassifyTasks.jsx
import React from "react";
import { ChevronRight } from "lucide-react";
import pandaImg from "../../../../../assets/panda_main.png";

const Card = ({ headerBg, title, bodyLetter, letterColor, returnsText, description }) => {
  return (
    <div className="relative rounded-lg overflow-hidden min-h-[300px] 2xl:min-h-[340.14111328125px]">

      {/* body */}
      <div className="bg-[#E9F7F6] p-8 text-center min-h-[300px] 2xl:min-h-[260px] flex flex-col items-center justify-center rounded-b-lg">
        <div className="text-[13px] 2xl:text-[14px] text-[#186D6C] font-medium font-gotham tracking-wide text-[#186D6C] uppercase">{title}</div>
        {description && <p className="text-[13px] 2xl:text-[14px] font-normal font-gotham leading-5 mt-1 text-[#323232] mb-3 max-w-[220px]">{description}</p>}
        {/* <div className="text-6xl font-bold" style={{ color: letterColor }}>{bodyLetter}</div> */}
        <div className="text-[50px] 2xl:text-[60px] font-semibold font-gotham mt-8 text-[#54B0AF]">{returnsText}</div>
        <div className="text-[12px] 2xl:text-[12.54px] text-[#54B0AF] font-gotham font-medium">RETURNS</div>
      </div>
    </div>
  );
};

const ClassifyTasks = ({ userId, subsectionId, onNextStep, onPreviousStep, onDataChange }) => {
  return (
    <div className="min-h-[600px] py-4 ">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row gap-0 items-start relative">
        {/* Left - Panda */}
        <div className="flex-shrink-0">
          <div className="w-[248px] h-[248px] lg:w-[260px] lg:h-[340px]">
            <img src={pandaImg} alt="Panda" className="w-full h-full lg:w-[460px] lg:h-[350px] object-contain absolute right-[70%]" />
          </div>
        </div>

        {/* Right - Content */}
        <div className="flex-1">
          <div className="mb-6">
            <p className="text-[14px] 2xl:text-[15px] text-[#7A7A7A] mt-2 max-w-3xl">
              As you grow in your career, the real skill is not doing more work, but choosing the right work. Not all work creates the same value. Here’s a simple way to think about where your time actually goes. Every task you do falls into one of these buckets, based on the impact it creates.
            </p>
          </div>

          {/* Cards row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            <Card
              headerBg="#E7FBFA"
              title="LEVERAGE TASKS"
              description="Work that moves the needle and creates clear impact on your promotability."
              bodyLetter="L"
              letterColor="#54B0AF"
              returnsText="10x"
            />

            <Card
              headerBg="#B7E7E650"
              title="NEUTRAL TASKS"
              description="Routine work that needs to be done to keep things running."
              bodyLetter="N"
              letterColor="#54B0AF"
              returnsText="1x"
            />

            <Card
              headerBg="#B7E7E64D"
              title="OVERHEAD TASKS"
              description="Work that eats up time and effort without adding real business value."
              bodyLetter="O"
              letterColor="#54B0AF"
              returnsText="<1x"
            />
          </div>

          {/* CTA */}
          <div className="flex justify-between items-center mt-8">
            <button
               onClick={onPreviousStep}
              className="px-6 py-3 rounded-full bg-[#000000] text-white flex items-center gap-3 font-gotham font-medium"
            >
              <span className="bg-white rounded-full p-2">
              <ChevronRight className="w-4 h-4 text-black rotate-180" />
              </span>
              <span className=" ont-gotham font-medium">Previous Step</span>
            </button>

            <button
              onClick={() => onNextStep?.()}
              className="px-6 py-3 rounded-full bg-black text-white flex items-center gap-3 font-gotham font-medium"
            >
              <span className="font-gotham font-medium">Get Started</span>
                <span className="bg-white rounded-full p-2">
              <ChevronRight className="w-4 h-4 text-black" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassifyTasks;